/**
 * `DeckCover` — the demo's `deckCover()` (demo line 1492): slide 1 of a
 * generated deck. Dark in both themes, the OEM's reversed logo, the title, a
 * subtitle, a meta line and a short accent rule in the corner. UI layer.
 */

import { OemLogo } from './OemLogo';

export function DeckCover({ title, sub, meta }: { title: string; sub: string; meta: string }) {
  return (
    <div
      className="deckcover relative mb-2.5 rounded-lg px-5 pb-7 pt-4"
      style={{ background: 'var(--color-zinc-900)', color: 'var(--color-zinc-50)' }}
    >
      <OemLogo height={26} reversed />
      <h4 className="mb-1 mt-3.5 text-[20px] font-semibold" style={{ color: 'var(--color-zinc-50)' }}>
        {title}
      </h4>
      <div className="sub text-[12.5px] opacity-90">{sub}</div>
      <div className="meta mt-1.5 text-[11px] opacity-70">{meta}</div>
      <i
        aria-hidden="true"
        className="absolute bottom-3.5 left-5 block h-[3px] w-12"
        style={{ background: 'var(--accent)' }}
      />
    </div>
  );
}
